import {closeDialog, openDialog, showNotification} from 'platform/components';

import {isNil} from 'ramda';
import {isArray} from 'ramda-adjunct';

import i18n from '@dms/i18n';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {CreateCoreExchangeDialog} from '../components/CreateCoreExchangeDialog/CreateCoreExchangeDialog';
import type {ReceiveJobItemRowData} from '../components/RequestEditDialog';

const CREATE_CORE_EXCHANGE_DIALOG_ID = 'createCoreExchange';

type ServiceItemRow = Pick<ReceiveJobItemRowData, 'serviceJobId' | 'serviceOrderJobItemId'>;

/**
 * Opens the core exchange creation for the row the `createCoreExchange` action was triggered
 * on. The action is single-row only (T20-129092), so a multi-row selection is ignored.
 * Without CORE_EXCHANGE_CREATE the dialog stays closed, even if the grid still offers the action.
 */
export const openCreateCoreExchangeDialog = (
  rowData: ServiceItemRow | ServiceItemRow[] | Nullish,
  serviceCaseId: string,
  serviceOrderId: string | Nullish,
  canCreateCoreExchange: boolean,
  testIdProps: TestIdProps
) => {
  if (!canCreateCoreExchange) {
    showNotification.error(i18n.t('general.notifications.noPermission'));
    return;
  }

  if (isArray(rowData) || isNil(rowData) || isNil(serviceOrderId)) {
    return;
  }

  openDialog(
    <CreateCoreExchangeDialog
      context={{
        serviceCaseId,
        serviceOrderId,
        serviceJobId: rowData.serviceJobId.value,
        serviceOrderJobItemId: rowData.serviceOrderJobItemId.value,
      }}
      onClose={() => closeDialog(CREATE_CORE_EXCHANGE_DIALOG_ID)}
      data-testid={suffixTestId('createCoreExchange', testIdProps)}
    />,
    {
      id: CREATE_CORE_EXCHANGE_DIALOG_ID,
      title: i18n.t('entity.coreExchange.actions.createCoreExchange'),
      size: 'large',
    }
  );
};
